import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { environment } from '../../environments/environment';
import { NotificationsService } from './notifications.service';

/**
 * Shape of a contact form submission coming from the Angular UI.
 */
export interface ContactMessagePayload {
  name: string;
  email: string;
  subject?: string;
  message: string;
  website?: string;
  gdprConsent: boolean;
}

interface ContactMessageResponse {
  success: boolean;
  id: string;
  emailNotificationSent: boolean;
}

@Injectable({ providedIn: 'root' })
export class ContactMessageService {
  constructor(
    private readonly http: HttpClient,
    private readonly notificationsService: NotificationsService
  ) {}

  /**
   * Sends the contact form payload to the Firebase HTTPS Cloud Function.
   * The Cloud Function handles persistence + email delivery.
   */
  submit(payload: ContactMessagePayload): Observable<ContactMessageResponse> {
    return this.http.post<ContactMessageResponse>(
      environment.contactFunctionUrl,
      payload,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      },
    ).pipe(
      tap(response => {
        if (!response || !response.emailNotificationSent) {
          return;
        }

        void this.notificationsService.logEmailNotification({
          title: 'Contact message emailed',
          message: `Contact message from ${payload.name} was emailed.`,
          email: payload.email,
          subject: payload.subject ?? 'Contact form submission',
          category: 'contact-message',
          metadata: {
            senderName: payload.name,
            senderEmail: payload.email
          }
        });
      })
    );
  }
}
